"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.7 20.6",
    width: "58.7",
    height: "20.6"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M58.2,16.5H53c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h4.7V1H1v12.5l6.9,2h21.4c0.3,0,0.5,0.2,0.5,0.5 s-0.2,0.5-0.5,0.5H7.8c0,0-0.1,0-0.1,0l-7.3-2.1C0.1,14.3,0,14.1,0,13.9V0.5C0,0.2,0.2,0,0.5,0h57.7c0.3,0,0.5,0.2,0.5,0.5V16 C58.7,16.3,58.5,16.5,58.2,16.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M3.9,20c-0.3,0-0.5-0.2-0.5-0.5v-4c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4C4.4,19.8,4.2,20,3.9,20z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M41.1,20.6c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2 C44.3,19.1,42.9,20.6,41.1,20.6z M41.1,15.2c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2S42.3,15.2,41.1,15.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M48.6,20.6c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2C51.8,19.1,50.4,20.6,48.6,20.6z M48.6,15.2c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2S49.8,15.2,48.6,15.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M33.6,20.6c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2 C36.8,19.1,35.3,20.6,33.6,20.6z M33.6,15.2c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2S34.8,15.2,33.6,15.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M9.9,16c-0.3,0-0.5-0.2-0.5-0.5v-15C9.4,0.2,9.7,0,9.9,0s0.5,0.2,0.5,0.5v15C10.4,15.8,10.2,16,9.9,16z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M17.9,16c-0.3,0-0.5-0.2-0.5-0.5v-15c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v15C18.4,15.8,18.2,16,17.9,16 z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M54.9,16c-0.3,0-0.5-0.2-0.5-0.5v-15c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v15C55.4,15.8,55.2,16,54.9,16 z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#EC6833",
    d: "M25.9,16c-0.3,0-0.5-0.2-0.5-0.5v-15c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v15C26.4,15.8,26.2,16,25.9,16 z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#EC6833",
    cx: "40.8",
    cy: "8.1",
    r: "4.7"
  }));
};

exports["default"] = _default;